import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
// import { Heart } from 'angular-feather/icons';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { timer, from } from 'rxjs';
import { concatMap, map, filter, take, switchMap, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CsvService {
  public baseurl = environment.apiUrl;
  private uploadApi = "api/Upload/";
  constructor(private http: HttpClient) { }

  importcsv(data) {
    const url = this.baseurl + this.uploadApi + 'ImportCSVFile';
    return this, this.http.post(url, data).pipe();
  }

  downloadCsvFile(data, filename = 'data') {
    let csvHeader;
    let csvTitle;
    if (filename == 'NotSavedData') {
      csvTitle = 'NotSavedData';
      csvHeader = ['Sr.No', 'TradeCode', 'ShippingLine', 'VesselName', 'VoyageNumber', 'PortName', 'ETA', 'Message']
      //  csvHeader = this.ConvertToCSV(data, ['TradeCode', 'ShippingLine', 'VesselName', 'VoyageNumber', 'PortName', 'ETA', 'Message'], filename);
    }
    else {
      csvTitle = 'SavedData';
      csvHeader = ['Sr.No', 'TradeCode', 'ShippingLine', 'VesselName', 'VoyageNumber', 'PortName', 'ETA']
      //   csvHeader = this.ConvertToCSV(data, ['TradeCode', 'ShippingLine', 'VesselName', 'VoyageNumber', 'PortName', 'ETA'], filename);
    }

    let csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: csvTitle,
      useBom: true,
      noDownload: false,
      headers: csvHeader
    };
    var data1 = new AngularCsv(data, csvTitle, csvOptions);

  }

  getImportStatus() {
    const url = this.baseurl + this.uploadApi + 'CsvImportResult';
    return this.http.get(url).pipe();
  }

  ConvertToCSV(objArray, headerList, filename) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'Sr.No,';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }

    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];
        // line += ',' + array[i].head;
        let line1 = this.getValues(array[i], head);
        if (line1 != '') {
          line += ',' + line1;
        }
      }
      str += line + '\r\n';
    }
    return str;
  }
  getValues(data, head) {
    let line = '';
    if (data != null) {
      if (head == 'TradeCode') {
        if (data.tradeCode.includes(',')) {
          line = data.tradeCode.replace(',', '');
        }
        else {
          line = data.tradeCode;
        }
      }
      else if (head == 'ShippingLine') {
        if (data.shippingLine.includes(',')) {
          line = data.shippingLine.replace(',', '');
        }
        else {
          line = data.shippingLine;
        }
      }
      else if (head == 'VesselName') {
        if (data.vesselName.includes(',')) {
          line = data.vesselName.replace(',', '');
        }
        else {
          line = data.vesselName;
        }
      }
      else if (head == 'VoyageNumber') {
        if (data.voyageNumber.includes(',')) {
          line = data.voyageNumber.replace(',', '');
        }
        else {
          line = data.voyageNumber;
        }
      }
      else if (head == 'PortName') {
        if (data.portName.includes(',')) {
          line = data.portName.replace(',', '');
        }
        else {
          line = data.portName;
        }
      }
      else if (head == 'ETA') {
        if (data.eta.includes(',')) {
          line = data.eta.replace(',', '');
        }
        else {
          line = data.eta;
        }
      }
      else if (head == 'Message') {
        if (data.message.includes(',')) {
          line = data.message.replace(',', '');
        }
        else {
          line = data.message;
        }
      }
    }
    return line;
  }
}
